var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('p',{staticClass:"w-full text-center py-5"},[_vm._v("© 2021 GiddyUp")])])}
var staticRenderFns = []

export { render, staticRenderFns }